var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.293,
    height: 10.008,
    viewBox: "0 0 14.293 10.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_1",
    "data-name": "Exclusion 1",
    d: "M19304.146-301.467a41.5,41.5,0,0,1-5.592-.31,1.79,1.79,0,0,1-1.26-1.26,18.734,18.734,0,0,1-.3-3.436,18.821,18.821,0,0,1,.3-3.436,1.834,1.834,0,0,1,1.26-1.275,44.174,44.174,0,0,1,5.592-.291,42.122,42.122,0,0,1,5.594.305,1.792,1.792,0,0,1,1.26,1.26,17.71,17.71,0,0,1,.291,3.451,19.2,19.2,0,0,1-.291,3.436,1.8,1.8,0,0,1-1.26,1.26A43.484,43.484,0,0,1,19304.146-301.467Zm-1.424-7.149h0v4.284l3.717-2.142-3.717-2.142Z",
    transform: "translate(-19296.998 311.475)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.97afe286c4deb77927c8d673b228d4cb.svg";
export { ForwardRef as ReactComponent };